exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!../assets/css/cover.css"), "");

// module
exports.push([module.id, ".site-wrapper-inner[data-v-815c61d2]{display:table-cell;vertical-align:middle}.mastfoot[data-v-815c61d2]{color:hsla(0,0%,100%,.5);position:fixed;bottom:0}@media (max-width:575px){.inner[data-v-815c61d2]{padding:.5rem 1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-815c61d2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LandingPage.vue
// module id = 94
// module chunks = 0